import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {SigninProposeComponent} from './signin-propose/signin-propose.component';
import {Observable, of} from 'rxjs';
import {first, map} from 'rxjs/operators';
import {AuthService} from '../../services/auth.service';

const REDIRECT_PATH_STORAGE_KEY = 'login.redirect.path';

@Injectable({
  providedIn: 'root'
})
export class SignInProposeService {

  constructor(
    private authService: AuthService,
    private matDialog: MatDialog,
    private router: Router
  ) {
  }

  showSignInProposal(redirectPath?: string, queryParams?: any): Observable<boolean> {
    console.log(redirectPath)
    if (this.authService.isLoggedIn()) {
      return of(false);
    }
    const dialogRef = this.matDialog.open(SigninProposeComponent,
      {
        autoFocus: false,
        panelClass: 'signin-propose-dialog',
        data: {queryParams}
      });
    return dialogRef.afterClosed().pipe(
      first(),
      map(result => {
        if (result) {
          if (redirectPath) {
            this.setRedirectPath(redirectPath);
          }
          this.router.navigate([result]);
          return true;
        }
        this.router.navigate['/home']
        return false;
      })
    );
  }

  restoreRedirectPath(): string {
    const rPath = sessionStorage.getItem(REDIRECT_PATH_STORAGE_KEY);
    if (rPath) {
      sessionStorage.removeItem(REDIRECT_PATH_STORAGE_KEY);
      return rPath;
    }
  }

  setRedirectPath(redirectPath: string): void{
    // Normalize the path to prevent double encoding issues
    // If the path is already encoded, decode it first
    let normalizedPath = redirectPath;
    try {
      // Check if the path contains encoded characters and decode if needed
      if (redirectPath.includes('%')) {
        normalizedPath = decodeURIComponent(redirectPath);
      }
    } catch (e) {
      // If decoding fails, use the original path
      normalizedPath = redirectPath;
    }
    sessionStorage.setItem(REDIRECT_PATH_STORAGE_KEY, normalizedPath);
  }
  
  setHigherInvitation(key){
    sessionStorage.setItem('higherInvitationKey', key);
  }

  getHigherInvitation(){    
    return sessionStorage.getItem('higherInvitationKey');
  }

  removeHigherInvitation(){
    sessionStorage.removeItem('higherInvitationKey');
  }

}
